import { render } from "./FloatButton.vue?vue&type=template&id=1de8286b&scoped=true"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"

import "./FloatButton.vue?vue&type=style&index=0&id=1de8286b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de8286b"]])

export default __exports__